// Shipments index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    pickupLocations: [],
    pickupAllowedFreightProducts: [],
    // PICKUP
    singlePickup: null,
    bookedPickupList: {
      items: [],
      entity: [],
      count: '',
    },
    notPlannedPickupList: {
      items: [],
      entity: [],
      count: '',
    },
    pickupShipmentsList: {
      items: [],
      entity: [],
      count: '',
    },
  },
  actions,
  mutations,
  getters
};
